import ApiClient from './ApiClient';

class CustomRole extends ApiClient {
  constructor() {
    super('roles', { accountScoped: true });
  }

  baseUrl() {
    return `/teletel/api/v1/accounts/${this.accountIdFromRoute}`;
  }
}

export default new CustomRole();
